var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("select-dialog", {
    ref: "selectDialog",
    attrs: {
      title: _vm.title,
      "row-data": _vm.rowData,
      "column-defs": _vm.columnDefs,
      "filter-keys": ["templateName", "pushLinkName"],
      value: _vm.finalTemplateUuid,
      "event-name": _vm.eventName,
      "display-name-field": _vm.displayNameField
    },
    on: { change: _vm.changeTrigger }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }